export const CallIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.4992 18.0376L18.3508 17.326L15.4108 20.266C12.1092 18.586 9.40249 15.891 7.72249 12.5776L10.6742 9.62598L9.96249 3.50098H3.53415C2.85749 15.3776 12.6225 25.1426 24.4992 24.466V18.0376Z"
      fill="white"
    />
  </svg>
);
